import React from 'react';
import { PropTypes } from 'prop-types';

import hideFromRoutes from '../hoc/hideFromRoutes';

const PromocardButton = ({ toggleCards, hasFolio }) => (
  <button type="button" className="btn btn--img ticket-promo" onClick={toggleCards} aria-label="Tengo tarjeta o promoción">
    <figure>
      <img src={require(!hasFolio ? '../static/images/ticket-promo.png' : '../static/images/promo-button-has-folio.png')} alt="" />
    </figure>
  </button>
);

PromocardButton.propTypes = {
  toggleCards: PropTypes.func
};

export default hideFromRoutes(
  PromocardButton, [
    '/error', 
    '/confirmacion', 
    '/', 
    '/butacas', 
    '/pago',
    '/pago/paypal/callback'
  ]
);
